import { createSlice, PayloadAction, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { FileOrFolder } from "../../../types/FileOrFolder";
import axios, { AxiosError } from "axios";
import toast from "react-hot-toast";

interface FileListState {
    itemsList: FileOrFolder[];
    loading: boolean;
    error: string | null;
    selectedItemsList: FileOrFolder[],
}

const initialState: FileListState = {
    itemsList: [],
    loading: false,
    error: null,
    selectedItemsList: [],
}

const fileListSlice = createSlice({
    name: "fileList",
    initialState,
    reducers: {
        // addItem: (state, action: PayloadAction<FileOrFolder>) => {
        //     state.items.push(action.payload);
        // },
        // deleteItem: (state, action: PayloadAction<string>) => {
        //     state.items = state.items.filter(folder => folder._id !== action.payload);
        // },
        // updateItem: (state, action: PayloadAction<FileOrFolder>) => {
        //     const index = state.items.findIndex(item => item._id === action.payload._id);
        //     if (index !== -1) {
        //         // ✅ Preserve existing x & y positions
        //         state.items[index] = {
        //             ...state.items[index], // Keep existing properties
        //             ...action.payload,     // Update with new values
        //             x: state.items[index].x, // Keep original x
        //             y: state.items[index].y  // Keep original y
        //         };
        //     }
        // },
        // Select Items reducers
        setSelectedItemsList: (state, action: PayloadAction<FileOrFolder[]>) => {
            state.selectedItemsList = action.payload;
        },
        toggleSelectedItemList: (state, action: PayloadAction<FileOrFolder>) => {
            const exists = state.selectedItemsList.some(item => item._id === action.payload._id);
        
            if (exists) {
                state.selectedItemsList = state.selectedItemsList.filter(item => item._id !== action.payload._id);
            } else {
                state.selectedItemsList.push(action.payload);
            }
        },
        addSelectedItemList: (state, action: PayloadAction<FileOrFolder>) => {
            // Add item only if it's not already selected
            if (!state.selectedItemsList.some(item => item._id === action.payload._id)) {
                state.selectedItemsList.push(action.payload);
            }
        },
        removeSelectedItemList: (state, action: PayloadAction<{ _id: string | null }>) => {
            // Remove selected item
            state.selectedItemsList = state.selectedItemsList.filter(item => item._id !== action.payload._id);
        },
        clearSelectedItemsList: (state) => {
            state.selectedItemsList = [];
        },
        // Clipboard stuff
        // copyItems: (state, action: PayloadAction<{ _id: string; name: string }[]>) => {
        //     state.clipboard = action.payload;
        //     state.clipboardType = "copy";
        // },
        // cutItems: (state, action: PayloadAction<{ _id: string; name: string }[]>) => {
        //     state.clipboard = action.payload;
        //     state.clipboardType = "cut";
        // },
        // clearClipboard: (state) => {
        //     state.clipboard = [];
        //     state.clipboardType = null;
        // },
    },
    extraReducers: (builder) => {
        builder
            // fetchItems pending, fulfilled, rejected
            // .addCase(fetchItemsList.pending, (state) => {
            //     state.loading = true;
            //     state.error = null;
            // })
            // .addCase(fetchItemsList.fulfilled, (state, action: PayloadAction<FileOrFolder[]>) => {
            //     state.loading = false;
            //     state.itemsList = action.payload;
            // })
            // .addCase(fetchItemsList.rejected, (state, action) => {
            //     state.loading = false;
            //     state.error = action.payload as string;
            // })
            // Fetching searched items
            // .addCase(fetchItemsSearch.pending || fetchItemsSearchEnhanced.pending, (state) => {
            //     state.loading = true;
            //     state.error = null;
            //     state.mode = 'search';
            // })
            // .addCase(fetchItemsSearch.fulfilled || fetchItemsSearchEnhanced.fulfilled, (state, action: PayloadAction<FileOrFolder[]>) => {
            //     state.loading = false;
            //     state.items = action.payload;
            //     state.mode = 'search';
            // })
            // .addCase(fetchItemsSearch.rejected || fetchItemsSearchEnhanced.rejected, (state, action) => {
            //     state.loading = false;
            //     state.error = action.payload as string;
            // })
            // Check for cutting! Moves items
            // .addCase(moveItemsDirectory.fulfilled, (state) => {
            //     if (state.clipboardType === "cut") {
            //         state.clipboard = [];
            //         state.clipboardType = null;
            //     }
            // })
            // .addCase(moveItemsDirectory.rejected, (state, action) => {
            //     state.error = action.payload as string;
            // })
    }
})

// export const fetchItemsSearchEnhanced = createAsyncThunk(
//     "fileExplorer/fetchItemsSearch",
//     async (search: string, { getState, rejectWithValue }) => {
//         try {
//             const response = await api.get(`/api/files-folders/search/enhanced?${search}`);
//             return response.data.items;
//         } catch (err) {
//             const error = err as AxiosError<{ message: string }>;
//             return rejectWithValue(error.response?.data?.message || "Error fetching items");
//         }
//     }
// )

// export const fetchItemsList = createAsyncThunk(
//     "fileExplorer/fetchItemsList",
//     async (_, { rejectWithValue }) => {
//         try {
//             const response = await api.get(`/api/files-folders/get-all-list`);
//             return response.data.items;
//         } catch (err) {
//             const error = err as AxiosError<{ message: string }>;
//             return rejectWithValue(error.response?.data?.message || "Error fetching items");
//         }
//     }
// )

// export const pasteItems = createAsyncThunk(
//     "fileExplorer/pasteItems",
//     async ({ x: startX, y: startY, newParentId }: { x: number; y: number; newParentId: string | null }, { getState, dispatch }) => {
//         const getLatestState = getState as () => { fileExplorerReducer: FileExplorerState };
//         const state = getLatestState().fileExplorerReducer; // Always get the latest state

//         try {
//             const parentIds = state.clipboard.map(item => ({
//                 _id: item._id,
//                 name: item.name
//             }));

//             const response = await api.post(`/api/files-folders/get-children`, { parentIds, newParentId, startX, startY });

//             // ✅ Extract the moved item IDs (fixing the incorrect format)
//             // const movedItemIds: string[] = response.data.rootItems.map((item: FileOrFolder) => item._id);
//             const movedItems: FileOrFolder[] = response.data.rootItems;
//             console.log('movedItems', movedItems);

//             await api.post(`/api/files-folders/resolve-overlaps-linear`, {
//                 parentId: newParentId,
//                 movedItems
//             })
            
//             // ✅ If any items were deleted, show a warning with item names
//             if (response.data.deletedItems?.length) {
//                 const deletedNames = response.data.deletedItems.join(", ");
//                 toast.error(`Some items were deleted before pasting: ${deletedNames}`);
//             }
            
//             await dispatch(fetchItems()).unwrap();

//             return;
//         } catch (error) {
//             if (axios.isAxiosError(error)) {
//                 if (error.response?.data?.error === "GRID_FULL") {
//                     toast.error("No space available! Delete some items first.");
//                 } else {
//                     toast.error(error.response?.data?.message);
//                 }
//             } else {
//                 console.error("Unexpected error:", error);
//                 toast.error("An unexpected error occurred.");
//             }
//         }
//     }
// );

// export const fetchAllMetadata = createAsyncThunk(
//     "fileExplorer/fetchAllMetadata",
//     async (_, { rejectWithValue }) => {
//         try {
//             const response = await api.get(`/api/files-folders/get-all-metadata`);
//             return response.data.metadata;
//         } catch (err) {
//             const error = err as AxiosError<{ message: string }>;
//             return rejectWithValue(error.response?.data?.message || "Error fetching metadata");
//         }
//     }
// )

export const { 
    setSelectedItemsList,
    toggleSelectedItemList,
    addSelectedItemList,
    removeSelectedItemList,
    clearSelectedItemsList,

    } = fileListSlice.actions;

export default fileListSlice.reducer;